import apiClient from '../../clienteFebosAPI';

const RESOURCE = '/aduanas/subastas';

export const auctionsList = ({ params = {} }) => {
  const parameters = apiClient.queryParams(params);
  return apiClient.get(`${RESOURCE}?${parameters}`, {
    operacionId: 'aduanas.auctions.list'
  });
};

export const auctionsListSearch = ({
  page, items, filters, order, format, query
}) => {
  const params = apiClient.queryParams(
    {
      filtros: filters,
      pagina: page,
      itemsPorPagina: items,
      orden: order,
      formato: format,
      q: query
    }
  );
  return apiClient.get(`/v2/buscar/aduana_subasta?${params}`, {
    operacionId: 'aduanas.auctions.search'
  });
};

export const auctionHistoryList = ({
  subastaId, page = 1, items, filters = undefined, order, format, query
}) => {
  const params = apiClient.queryParams(
    {
      filtros: filters,
      paginaActual: page,
      elementosPorPagina: items,
      orden: order,
      formato: format,
      q: query
    }
  );
  return apiClient.get(`${RESOURCE}/${subastaId}/historial?${params}`, {
    operacionId: 'aduanas.auctions.history'
  });
};

export const auctionBatchesDelete = ({ subastaId, lotes }) => apiClient.post(
  `${RESOURCE}/${subastaId}/lotes/desasociar`, { lotes }, {
    operacionId: 'aduanas.auctions.batches.delete'
  }
);

export const auctionBatchesAdd = ({ subastaId, lotes }) => apiClient.post(
  `${RESOURCE}/${subastaId}/lotes/asociar`, { lotes }, {
    operacionId: 'aduanas.auctions.batches.asociar'
  }
);

export const auctionBatchesList = (payload) => apiClient.get(
  `${RESOURCE}/${payload.subastaId}/lotes`, {
    operacionId: 'aduanas.auctions.batches.list'
  }
);

export const createAuction = (auction) => apiClient.post(`${RESOURCE}`, auction, {
  operacionId: 'aduanas.auctions.create'
});

export const updateAuction = (auction) => apiClient.patch(`${RESOURCE}/${auction.subastaId}`, auction, {
  operacionId: 'aduanas.auctions.update'
});

export const auctionsUpdateStatus = ({ subastaId, accion }) => apiClient.put(
  `${RESOURCE}/${subastaId}/${accion}`, {}, {
    operacionId: 'aduanas.auctions.update.status'
  }
);
